import { render, staticRenderFns } from "./EmulatorNavigationItem.vue?vue&type=template&id=0806626e&scoped=true"
import script from "./EmulatorNavigationItem.vue?vue&type=script&lang=js"
export * from "./EmulatorNavigationItem.vue?vue&type=script&lang=js"
import style0 from "./EmulatorNavigationItem.vue?vue&type=style&index=0&id=0806626e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0806626e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0806626e')) {
      api.createRecord('0806626e', component.options)
    } else {
      api.reload('0806626e', component.options)
    }
    module.hot.accept("./EmulatorNavigationItem.vue?vue&type=template&id=0806626e&scoped=true", function () {
      api.rerender('0806626e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Emulator/EmulatorNavigationItem.vue"
export default component.exports